import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../components/Navbar";
import Styles from "../../styles/exercise/createexercise.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { adminRoutes } from "../../routers/AdminRouters";
import {
  editExercise,
  exerciseVideoDelete,
  exerciseVideoDeleteSecondary,
  getCategory,
  getExerciseById,
  getOptions,
  uploadVideos,
  uploadVideoSecondary,
} from "../../services";
import cancelIcon from "../../assets/exersise/cancel-circle.png";
import uploadIcon from "../../assets/exersise/upload.png";
import deleteIcon from "../../assets/exersise/trash.png";
import {
  changeExercisePrimaryVideoLoading,
  changeExercisePrimaryVideoProgress,
  changeExerciseSecondaryVideoLoading,
  changeExerciseSecondaryVideoProgress,
  dispatch,
  toggle,
} from "../../redux";
import { ApiEndpoints } from "../../core";
function hhmmssToSeconds(time) {
  const [hours, minutes, seconds] = time.split(":").map(Number);
  return hours * 3600 + minutes * 60 + seconds;
}

function secondsToHhmmss(totalSeconds) {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return [hours, minutes, seconds]
    .map((unit) => String(unit).padStart(2, "0"))
    .join(":");
}

const EditExercise = () => {
  const [fileThumbnailHD, setFileThumbnailHD] = useState(null);
  const [fileThumbnail4K, setFileThumbnail4K] = useState(null);
  const [selectedHdFile, setSelectedHdFile] = useState(null);
  const [selectedFourKFile, setSelectedFourkFile] = useState(null);
  const [uploadController, setUploadController] = useState(null);
  const [uploadControllerSecondary, setUploadControllerSecondary] =
    useState(null);

  const navigate = useNavigate();
  const progressBar = useSelector(
    (state) => state.exercises.primaryVideoUploadProgress
  );
  const progressBarSecondary = useSelector(
    (state) => state.exercises.secondaryVideoUploadProgress
  );
  const primaryVideoKey = useSelector(
    (state) => state.exercises.primaryVideoKey
  );
  const secondaryVideoKey = useSelector(
    (state) => state.exercises.secondaryVideoKey
  );
  const { options } = useSelector((state) => state.exercises);

  const { exerciseId } = useParams();
  const { categories } = useSelector((state) => state.exercises);
  const isSidebarOpen = useSelector((state) => state.navbar.button);
  const dispatch = useDispatch();
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [time, setTime] = useState();
  const nameRef = useRef();
  const categoryRef = useRef();
  const typeRef = useRef();
  const setRef = useRef();
  const repRef = useRef();
  const tempRef = useRef();
  const calRef = useRef();
  const meterRef = useRef();
  const hoursRef = useRef(null);
  const minutesRef = useRef(null);
  const secondsRef = useRef(null);
  const blockTimingRef = useRef(null);
  const wordPeriodsRef = useRef(null);
  const restPeriodsRef = useRef(null);
  const [exerciseDetails, setExerciseDetails] = useState({
    name: "",
    category: "",
    type: "",
    hdVideo: "",
    hdVideoSize: "",
    fourKVideo: "",
    fourKVideoSize: "",
    sets: "",
    reps: "",
    tempos: "",
    calories: "",
    meters: "",
    time: "",
    blockTimings: "",
    workPeriods: "",
    restPeriods: "",
  });
  const handleMainContainerClick = () => {
    if (isSidebarOpen) {
      dispatch(toggle());
    }
  };
  useEffect(() => {
    const fetchData = () => {
      getCategory();
      getOptions();
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchExercise = async () => {
      try {
        const response = await getExerciseById(exerciseId);

        setExerciseDetails({
          name: response.name || "",
          category: response.category || "",
          type: response.type || "",
          hdVideo: response.videos?.primary
            ? `${ApiEndpoints.baseAssetUrl}/${response.videos.primary}`
            : "",
          hdVideoSize: response.hdVideoSize || "",
          fourKVideo: response.videos?.secondary
            ? `${ApiEndpoints.baseAssetUrl}/${response.videos.secondary}`
            : "",
          fourKVideoSize: response.fourKVideoSize || "",
          sets: response.variables?.sets || "",
          reps: response.variables?.reps || "",
          cals: response.variables?.cals || "",
          tempos: response.variables?.tempos || "", // Fixed key mismatch
          calories: response.variables?.cals || "", // Fixed key mismatch
          meters: response.variables?.meters || "",
          time: response.variables?.time || "", // Add checks if this exists in the response
          blockTimings: response.times?.blockTimings || "",
          workPeriods: response.times?.workPeriods || "",
          restPeriods: response.times?.restPeriods || "",
        });
      } catch (err) {
        console.error("Error fetching exercise details:", err);
      }
    };

    if (exerciseId) {
      fetchExercise();
    }
  }, [exerciseId]);
  useEffect(() => {
    if (exerciseDetails.time) {
      const formattedTime = secondsToHhmmss(exerciseDetails.time);
      const [hours, minutes, seconds] = formattedTime.split(":");

      if (hoursRef.current) hoursRef.current.value = hours || "00";
      if (minutesRef.current) minutesRef.current.value = minutes || "00";
      if (secondsRef.current) secondsRef.current.value = seconds || "00";

      setTime(hhmmssToSeconds(formattedTime));
    }
  }, [exerciseDetails.time]);

  const handleCategoryChange = (event) => {
    const categoryId = event.target.value;
    const selected = categories.find((cat) => cat._id === categoryId);

    setSelectedCategory(selected || {});

    setExerciseDetails((prev) => ({
      ...prev,
      category: selected || "",
      type: "", // Reset type when category changes
    }));
  };

  const handleSubCategoryChange = (event) => {
    const subCategory = event.target.value;
    setSelectedSubCategory(subCategory);

    setExerciseDetails((prev) => ({
      ...prev,
      type: subCategory, // Update type when subcategory changes
    }));
  };

  const handleTimeChange = () => {
    const hours = hoursRef.current?.value.padStart(2, "0") || "00";
    const minutes = minutesRef.current?.value.padStart(2, "0") || "00";
    const seconds = secondsRef.current?.value.padStart(2, "0") || "00";

    const newTimeInSeconds = hhmmssToSeconds(`${hours}:${minutes}:${seconds}`);

    setTime(newTimeInSeconds);

    setExerciseDetails((prev) => ({
      ...prev,
      time: newTimeInSeconds,
    }));
  };

  const handleSubmit = async () => {
    if (!nameRef.current || !setRef.current || !repRef.current) {
      console.error("One or more refs are undefined.");
      return;
    }
    const formData = {
      name: nameRef.current.value,
      category: categoryRef.current.value,
      type: selectedSubCategory,

      videos: {
        primary: primaryVideoKey || "",
        secondary: secondaryVideoKey || "",
      },
      // variables: {
      //   sets: setRef.current.value,
      //   reps: repRef.current.value,
      //   tempos: tempRef.current?.value,
      //   cals: calRef.current?.value,
      //   meters: meterRef.current?.value,
      //   time: time,
      // },
      // times: {
      //   blockTimings: blockTimingRef.current?.value,
      //   workPeriods: wordPeriodsRef.current?.value,
      //   restPeriods: restPeriodsRef.current?.value,
      // },
    };

    const success = await editExercise(exerciseId, formData);

    if (success) {
      navigate(adminRoutes.listExercise);
    } else {
      console.error("Failed to add exercise.");
    }
  };

  const handleFileUpload = async (event) => {
    const video = event.target.files[0];
    if (video) {
      setSelectedHdFile(video);
      const fileURL = URL.createObjectURL(video);
      setFileThumbnailHD(fileURL);
      const controller = new AbortController();
      setUploadController(controller);
      const formData = new FormData();
      formData.append("video", video);
      await uploadVideos(video, controller.signal);
    }
  };
  const handleCancel = () => {
    if (uploadController) {
      uploadController.abort();
      console.log("Upload canceled by the user");
      dispatch(changeExercisePrimaryVideoProgress(0));
      dispatch(changeExercisePrimaryVideoLoading(false));
    }
  };
  const triggerFileInput = () => {
    document.getElementById("upload-hd-input").click();
  };
  const handleReuploadHd = () => {
    if (selectedHdFile) {
      uploadVideos(selectedHdFile);
    } else {
      console.error("No file selected for reupload");
    }
  };

  const handleCancelSecondary = () => {
    if (uploadControllerSecondary) {
      uploadControllerSecondary.abort();
      console.log("Upload canceled by the user");
      dispatch(changeExerciseSecondaryVideoProgress(0));
      dispatch(changeExerciseSecondaryVideoLoading(false));
    }
  };
  const handleFileUploadSecondary = async (event) => {
    const video = event.target.files[0];
    if (video) {
      setSelectedFourkFile(video);
      const fileURL = URL.createObjectURL(video);
      setFileThumbnail4K(fileURL);
      const controller = new AbortController();
      setUploadControllerSecondary(controller);
      const formData = new FormData();
      formData.append("video", video);
      await uploadVideoSecondary(video, controller.signal); // Ensure proper payload format
    }
  };
  const triggerFileInputSecondary = () => {
    document.getElementById("upload-secondary-input").click();
  };
  const handleReuploadFourK = () => {
    if (selectedFourKFile) {
      uploadVideoSecondary(selectedFourKFile);
    } else {
      console.error("No file selected for reupload");
    }
  };
  const handleDelete = async (key) => {
    const resp = await exerciseVideoDelete(key);

    setFileThumbnailHD(null);
  };
  const handleDelete4k = async (key) => {
    const resp = await exerciseVideoDeleteSecondary(key);

    setFileThumbnail4K(null);
  };
  const handleBack = () => {
    navigate(adminRoutes.listExercise);
  };

  //   useEffect(() => {
  //   if (exerciseDetails.hdVideo) {
  //     setFileThumbnailHD(exerciseDetails.hdVideo);
  //   }
  //   if (exerciseDetails.fourKVideo) {
  //     setFileThumbnail4K(exerciseDetails.fourKVideo);
  //   }
  // }, [exerciseDetails.hdVideo, exerciseDetails.fourKVideo]);

  return (
    <>
      <Navbar />
      <div
        className={Styles.createexercise_main}
        onClick={handleMainContainerClick}
      >
        <div className={Styles.createexercise_container}>
          <h2>
            <Link to={adminRoutes.dashboard} className={Styles.dark}>
              HOME /
            </Link>{" "}
            <Link to={adminRoutes.listExercise} className={Styles.white}>
              ALL EXERCISE /
            </Link>{" "}
            <span className={Styles.orange}>EDIT EXERCISE</span>
          </h2>
        </div>
        <div className={Styles.form_container}>
          <div className={Styles.table_container_headingone}>
            <h3>EDIT EXERCISE</h3>
          </div>

          <div className={Styles.row_padding}>
            <div className={Styles.row}>
              <div className={Styles.input_group}>
                <label>Exercise Name</label>
                <input
                  type="text"
                  placeholder="Enter here"
                  ref={nameRef}
                  defaultValue={exerciseDetails.name}
                />
              </div>
              <div className={Styles.input_group}>
                <label>Category</label>
                <select onChange={handleCategoryChange} ref={categoryRef} className={Styles.dropdown_select}>
                  <option value={exerciseDetails.category._id}>
                    {" "}
                    {exerciseDetails.category.name || "Choose from list"}
                  </option>
                  {categories.map((category) => (
                    <option key={category._id} value={category._id}>
                      {category.name}
                    </option>
                  ))}
                </select>
              </div>
              {selectedCategory?.subCategories?.length > 0 && (
                <div className={Styles.input_radio}>
                  <span>Types</span>
                  {selectedCategory.subCategories.map((subCategory, index) => (
                    <label key={index}>
                      <input
                        type="radio"
                        name="subCategories"
                        value={subCategory}
                        checked={selectedSubCategory === subCategory}
                        onChange={handleSubCategoryChange}
                      />
                      {subCategory || "N/A"}
                    </label>
                  ))}
                </div>
              )}
              <div className={Styles.thumbnail_container}>
                { exerciseDetails?.hdVideo  && !fileThumbnailHD? (
                  <video
                    src={exerciseDetails.hdVideo}
                    muted
                    className={Styles.thumbnail}
                  />
                ) : (
                  <></>
                )}
              </div>

              <div className={Styles.input_group_upload}>
                {!fileThumbnailHD && (
                  
                  <div>
                    {" "}
                    <label>HD Video</label>
                    <button
                      style={{ marginTop: "1em" }}
                      onClick={triggerFileInput}
                    >
                      <img src={uploadIcon} alt="Upload Icon" />
                      Upload
                    </button>
                  </div>
                )}
                <input
                  type="file"
                  id="upload-hd-input"
                  accept="video/*"
                  style={{ display: "none" }}
                  onChange={handleFileUpload}
                />

                {fileThumbnailHD && (
                  <div className={Styles.thumbnail_container}>
                    <video
                      src={fileThumbnailHD}
                      muted
                      className={Styles.thumbnail}
                    />
                  </div>
                )}

                {progressBar !== 0 && (
                  <div className={Styles.progress_container}>
                    <div
                      className={`${Styles.progress_bar} ${
                        progressBar === -1
                          ? Styles.error
                          : progressBar === 100
                          ? Styles.success
                          : Styles.uploading
                      }`}
                      style={{
                        width: `${
                          progressBar === -1 ? "100%" : progressBar + "%"
                        }`,
                      }}
                    ></div>
                  </div>
                )}
                {progressBar === -1 && (
                  <>
                    <button
                      onClick={handleReuploadHd}
                      className={Styles.reupload_button}
                    >
                      <img src={uploadIcon} alt="Reupload Icon" />
                      <span id={Styles.reupload}> Reupload</span>
                    </button>
                    <button
                      onClick={() => handleDelete(primaryVideoKey)}
                      className={Styles.delete_button}
                      style={{ background: "transparent" }}
                    >
                      <img src={deleteIcon} alt="Delete Icon" />
                    </button>
                  </>
                )}

                {progressBar > 0 && progressBar < 100 && (
                  <button
                    className={Styles.cancel_button}
                    onClick={handleCancel}
                    style={{ background: "transparent" }}
                  >
                    <img src={cancelIcon} alt="Cancel Icon" />
                  </button>
                )}
                {progressBar === 100 && (
                  <button
                    onClick={() => handleDelete(primaryVideoKey)}
                    className={Styles.delete_button}
                    style={{ background: "transparent" }}
                  >
                    <img src={deleteIcon} alt="Delete Icon" />
                  </button>
                )}
              </div>
              <div className={Styles.thumbnail_container}>
              { exerciseDetails?.fourKVideo  && !fileThumbnail4K? (
                  <video
                    src={exerciseDetails.fourKVideo}
                    muted
                    className={Styles.thumbnail}
                  />
                ) : (
                  <></>
                )}
              </div>
              <div className={Styles.input_group_upload}>
                {!fileThumbnail4K && (
                  <div>
                    {" "}
                    <label>4K Video</label>
                    <button
                      style={{ marginTop: "1em" }}
                      onClick={triggerFileInputSecondary}
                    >
                      <img src={uploadIcon} alt="Upload Icon" />
                      Upload
                    </button>
                  </div>
                )}
                <input
                  type="file"
                  id="upload-secondary-input"
                  accept="video/*"
                  style={{ display: "none" }}
                  onChange={handleFileUploadSecondary}
                />

                {fileThumbnail4K && (
                  <div className={Styles.thumbnail_container}>
                    <video
                      src={fileThumbnail4K}
                      muted
                      className={Styles.thumbnail}
                    />
                  </div>
                )}

                {progressBarSecondary !== 0 && (
                  <div className={Styles.progress_container}>
                    <div
                      className={`${Styles.progress_bar} ${
                        progressBarSecondary === -1
                          ? Styles.error
                          : progressBarSecondary === 100
                          ? Styles.success
                          : Styles.uploading
                      }`}
                      style={{
                        width: `${
                          progressBarSecondary === -1
                            ? "100%"
                            : progressBarSecondary + "%"
                        }`,
                      }}
                    ></div>
                  </div>
                )}

                {progressBarSecondary === -1 && (
                  <>
                    <button
                      onClick={handleReuploadFourK}
                      className={Styles.reupload_button}
                    >
                      <img src={uploadIcon} alt="Reupload Icon" />
                      <span id={Styles.reupload}> Reupload</span>
                    </button>
                    <button
                      onClick={() => handleDelete4k(secondaryVideoKey)}
                      className={Styles.delete_button}
                      style={{ background: "transparent" }}
                    >
                      <img src={deleteIcon} alt="Delete Icon" />
                    </button>
                  </>
                )}
                {progressBarSecondary > 0 && progressBarSecondary < 100 && (
                  <button
                    className={Styles.cancel_button}
                    onClick={handleCancelSecondary}
                    style={{ background: "transparent" }}
                  >
                    <img src={cancelIcon} alt="Cancel Icon" />
                  </button>
                )}
                {progressBarSecondary === 100 && (
                  <button
                    onClick={() => handleDelete4k(secondaryVideoKey)}
                    className={Styles.delete_button}
                    style={{ background: "transparent" }}
                  >
                    <img src={deleteIcon} alt="Delete Icon" />
                  </button>
                )}
              </div>
            </div>
            {/* <div className={Styles.seperator}>
              <span className={Styles.title}>VARIABLE</span> &nbsp;&nbsp;
              <hr className={Styles.line} />
            </div>
            <div className={Styles.row}>
              <div className={Styles.input_group}>
                <label>Sets</label>
                <select ref={setRef} className={Styles.dropdown_select}>
                  <option value="">
                    {exerciseDetails.sets || "Choose from list"}
                  </option>{" "}
                  {options.sets.map((item, index) => (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  ))}{" "}
                </select>
              </div>
              <div className={Styles.input_group}>
                <label>Reps</label>
                <select ref={repRef} className={Styles.dropdown_select}>
                  <option value="">
                    {exerciseDetails.reps || "Choose from list"}
                  </option>{" "}
                  {options.reps.map((item, index) => (
                    <option key={index} value={item}>
                      {item === -1 ? "Max" : item}
                    </option>
                  ))}{" "}
                </select>
              </div>
              <div className={Styles.input_group}>
                <label>Tempo</label>
                <select ref={tempRef} className={Styles.dropdown_select}>
                  <option value="">
                    {exerciseDetails.tempos || "Choose from list"}
                  </option>{" "}
                  {options.tempos.map((item, index) => (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  ))}{" "}
                </select>
              </div>
            </div>
            <br />
            <div className={Styles.row}>
              <div className={Styles.input_group}>
                <label>Cals</label>
                <select ref={calRef} className={Styles.dropdown_select} defaultChecked={exerciseDetails.cals} >
                  <option value="">
                    {exerciseDetails.cals || "Choose from list"}
                  </option>{" "}
                  {options.cals.map((item, index) => (
                    <option key={index} value={item}>
                      {item === -1 ? "Max" : item}
                    </option>
                  ))}{" "}
                </select>
              </div>

              <div className={Styles.input_group}>
                <label>Meters</label>
                <select ref={meterRef} defaultChecked={exerciseDetails.meters} className={Styles.dropdown_select}>
                  <option value="">
                    {exerciseDetails.meters || "Choose from list"}
                  </option>{" "}
                  {options.meters.map((item, index) => (
                    <option key={index} value={item}>
                      {item === -1 ? "Max" : item}
                    </option>
                  ))}{" "}
                </select>
              </div>

              <div className={Styles.input_group}>
                <label>Time</label>
                <div className={Styles.time_field}>
                  <span className={Styles.icon}>
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 25 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.333 22C17.8559 22 22.333 17.5228 22.333 12C22.333 6.47715 17.8559 2 12.333 2C6.81016 2 2.33301 6.47715 2.33301 12C2.33301 17.5228 6.81016 22 12.333 22Z"
                        stroke="#808080"
                        stroke-width="1.5"
                      />
                      <path
                        d="M12.333 8V12L14.333 14"
                        stroke="#808080"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                  <input
                    type="text"
                    placeholder="00"
                    maxLength={2}
                    className={Styles.time_input}
                    ref={hoursRef}
                    defaultValue={
                      secondsToHhmmss(exerciseDetails.time).split(":")[0] ||
                      "00"
                    }
                    onChange={handleTimeChange}
                    onKeyDown={(e) => {
                      if (e.key === '-') {
                        e.preventDefault();
                      }
                    }}
                  />
                  <input
                    type="text"
                    placeholder="00"
                    maxLength={2}
                    className={Styles.time_input}
                    ref={minutesRef}
                    defaultValue={
                      secondsToHhmmss(exerciseDetails.time).split(":")[1] ||
                      "00"
                    }
                    onChange={handleTimeChange}
                    onKeyDown={(e) => {
                      if (e.key === '-') {
                        e.preventDefault();
                      }
                    }}
                  />
                  <input
                    type="text"
                    placeholder="00"
                    maxLength={2}
                    className={Styles.time_input}
                    ref={secondsRef}
                    defaultValue={
                      secondsToHhmmss(exerciseDetails.time).split(":")[2] ||
                      "00"
                    }
                    onChange={handleTimeChange}
                    onKeyDown={(e) => {
                      if (e.key === '-') {
                        e.preventDefault();
                      }
                    }}
                  />
                </div>
              </div>
            </div>
            <div className={Styles.seperator}>
              <span className={Styles.title}>TIME</span> &nbsp;&nbsp;
              <hr className={Styles.line} />
            </div>{" "}
            <div className={Styles.row}>
              <div className={Styles.input_group}>
                <label>Block Timings</label>
                <select ref={blockTimingRef} className={Styles.dropdown_select}>
                  <option value={exerciseDetails.blockTimings}>
                    {exerciseDetails.blockTimings >= 90
                      ? `${exerciseDetails.blockTimings / 60} minute(s)`
                      : `${exerciseDetails.blockTimings} second(s)` ||
                        "Choose from list"}
                  </option>
                  {options.blockTimings
                    .filter((item) => item !== exerciseDetails.blockTimings)
                    .map((item, index) => (
                      <option key={index} value={item}>
                        {item >= 90
                          ? `${item / 60} minute(s)`
                          : `${item} second(s)`}
                      </option>
                    ))}
                </select>
              </div>
              <div className={Styles.input_group}>
                <label>Work Periods</label>
                <select ref={wordPeriodsRef} className={Styles.dropdown_select}>
                  <option value={exerciseDetails.workPeriods} >
                    {exerciseDetails.workPeriods >= 60
                      ? `${exerciseDetails.workPeriods / 60} minute(s)`
                      : `${exerciseDetails.workPeriods} second(s)` ||
                        "Choose from list"}
                  </option>
                  {options.workPeriods
                    .filter((item) => item !== exerciseDetails.workPeriods)

                    .map((item, index) => (
                      <option key={index} value={item}>
                        {item >= 90
                          ? `${item / 60} minute(s)`
                          : `${item} second(s)`}
                      </option>
                    ))}{" "}
                </select>
              </div>
              <div className={Styles.input_group}>
                <label>Rest Periods</label>
                <select ref={restPeriodsRef} className={Styles.dropdown_select}>
                  <option value={exerciseDetails.restPeriods}>
                    {exerciseDetails.restPeriods >= 60
                      ? `${exerciseDetails.restPeriods / 60} minute(s)`
                      : `${exerciseDetails.restPeriods} second(s)` ||
                        "Choose from list"}
                  </option>{" "}
                  {options.restPeriods
                    .filter((item) => item !== exerciseDetails.restPeriods)

                    .map((item, index) => (
                      <option key={index} value={item}>
                        {item >= 90
                          ? `${item / 60} minute(s)`
                          : `${item} second(s)`}
                      </option>
                    ))}{" "}
                </select>
              </div>
            </div> */}
          </div>

          <div className={Styles.button_group_line} />

          <div className={Styles.button_group}>
            <button
              className={Styles.save_button}
              onClick={handleSubmit}
              style={{ cursor: "pointer" }}
            >
              Save
            </button>
            <button
              className={Styles.cancel_button}
              onClick={handleBack}
              style={{ cursor: "pointer" }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditExercise;
